import React, { useMemo } from 'react';
import { DeleteOutlined, MoreOutlined } from '@ant-design/icons';
import { Dropdown, Button, Tooltip } from 'antd';
import { MenuProps } from 'antd/lib';
import { ReactComponent as PaperPlane } from '../../resources/img/paperPlane.svg';
import { useTranslation } from 'react-i18next';

type BookingOrderDetailsDropdownButtonProps = {
  setShowSendConfirmationEmailModal: (value: boolean) => void;
  setShowDeleteBookingOrderModal: (value: boolean) => void;
  disableDelete: boolean;
  hideResendConfirmation: boolean;
};

enum DropdownKeys {
  Confirmation = 'confirmation',
  Delete = 'delete',
}

const BookingOrderDetailsDropdownButton: React.FC<
  BookingOrderDetailsDropdownButtonProps
> = ({
  setShowSendConfirmationEmailModal,
  setShowDeleteBookingOrderModal,
  disableDelete,
  hideResendConfirmation,
}) => {
  const { t } = useTranslation();

  const onClick: MenuProps['onClick'] = ({ key }) => {
    switch (key) {
      case DropdownKeys.Confirmation:
        setShowSendConfirmationEmailModal(true);
        break;
      case DropdownKeys.Delete:
        setShowDeleteBookingOrderModal(true);
        break;
    }
  };

  const dropdownItems: MenuProps['items'] = useMemo(() => {
    const items: MenuProps['items'] = [];

    if (!hideResendConfirmation) {
      items.push(
        {
          key: DropdownKeys.Confirmation,
          label: (
            <div className="flex overflow whitespace-normal break-words">
              <PaperPlane className="flex mr-1 mt-1" />
              {t('components.BookingOrderDetailsDropdownButton.resendOverview')}
            </div>
          ),
        },
        { type: 'divider' },
      );
    }

    items.push({
      key: DropdownKeys.Delete,
      danger: true,
      disabled: disableDelete,
      label: (
        <Tooltip
          placement="left"
          title={
            disableDelete
              ? t('components.BookingOrderDetailsDropdownButton.cannotDelete')
              : ''
          }>
          <div>
            <DeleteOutlined className="mr-1" />
            {t('common.delete')}
          </div>
        </Tooltip>
      ),
    });

    return items;
  }, [hideResendConfirmation, disableDelete, t]);

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items: dropdownItems, onClick: onClick }}
      placement="bottomRight">
      <div>
        <Button
          type="text"
          className="rounded-full"
          icon={<MoreOutlined className="text-xl" />}></Button>
      </div>
    </Dropdown>
  );
};

export default BookingOrderDetailsDropdownButton;
